
var utmObj = {};


// 根据环境设置host
window.solution_host = 'https://www.dellemc-solution.com';
window.solution_m_host = 'https://m.dellemc-solution.com';
window.eshop_host = 'https://www.dellemc-solution.com/eshop';

if( window.location.host.indexOf('local.')>-1){
    window.solution_host = 'http://local.dellemc-solution.com';
    window.solution_m_host = 'http://mlocal.dellemc-solution.com';
    window.eshop_host = 'http://local.dellemc-solution.com/eshop';
}
if(window.location.host.indexOf('test.')>-1){
    window.solution_host = 'https://test.dellemc-solution.com';
    window.solution_m_host = 'https://mtest.dellemc-solution.com';
    window.eshop_host = 'https://test.dellemc-solution.com/eshop';
}
if(window.location.host.indexOf('uat.')>-1){
    window.solution_host = 'https://uat.dellemc-solution.com';
    window.solution_m_host = 'https://muat.dellemc-solution.com';
    window.eshop_host = 'https://uat.dellemc-solution.com/eshop';
}

(function () {
    var common = {
        //获取地址栏参数
        getUrlPara: function (name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r !== null) {
                return decodeURIComponent(r[2]);
            }
            return this.getHashPara(name) || null;
        },

        // 获取Hash参数
        getHashPara: function (key) {
            var params = this.getHashParameters();
            return params?params[key]:null;
        },

        getHashParameters: function () {
            if(!location.hash){
                return null;
            }
            var arr = [];
            if(location.hash.indexOf('?')>-1){// hash中带有？的处理方法
                arr = (location.hash || "").split('#')[1].split('?')[1].replace(/^\?/,'').split("&");
            }else{
                arr = (location.hash || '').split('#')[1].split('&');
            }
            var params = {}
            for (var i = 0; i < arr.length; i++) {
                var data = arr[i].split('=');
                if (data.length === 2) {
                    params[data[0]] = data[1]
                }
            }
            return params;
        },

        isM: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

        //手机号脱敏
        mobileEncryption:function(mobile) {
            if(!mobile){
                return false;
            }
            return mobile.substr(0,4) + '***' + mobile.substr(7,4);
        },

        //获取cookie
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if ((arr = document.cookie.match(reg))) {
                return decodeURIComponent(arr[2]);
            } else {
                return null;
            }
        },

        //写cookie
        setCookie: function (name, value, days) {
            var Days = days || 30;
            var exp = new Date();
            exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
            document.cookie =
                name +
                "=" +
                encodeURIComponent(value) +
                ";expires=" +
                exp.toGMTString() +
                ";domain=.dellemc-solution.com;path=/";
        },

        getJson: function (url, info, callback, cross) {
            $.ajax({
                type: "GET",
                url: url,
                data: info,
                dataType: "json",
                contentType: 'text/plain',
                crossDomain: cross || false,
                xhrFields: {
                    withCredentials: cross || false
                },
                success: function (data) {
                    callback(data);
                },
                error: function (data) {
                    if (window.isDebug) {
                        console.log(data);
                    }
                }
            });
        },

        gotoUrl(url, blank){
            if(!url) {
                return;
            }

            if(blank === undefined){
                blank = true
            }

            if(url.indexOf('//') === -1){
                if(common.isM){
                    url = solution_m_host + url;
                }else{
                    url = solution_host + url;
                }
            }

            if(blank){
                if(common.isM){
                    location.href = url;
                }else{
                    window.open(url)
                }
            }else{
                location.href = url;
            }
        },
    };

    window.common = common;

    // 获取utm字段，任意一个字段有值，把所有的值都替换，都无值的时候，取现有cookie
    var utm_source = common.getUrlPara("utm_source") || "";
    var utm_medium = common.getUrlPara("utm_medium") || "";
    var utm_campaign = common.getUrlPara("utm_campaign") || "";
    var utm_content = common.getUrlPara("utm_content") || "";
    var utm_term = common.getUrlPara("utm_term") || "";
    if (utm_source || utm_medium || utm_campaign || utm_content || utm_term) {
        utmObj = {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_content: utm_content,
            utm_term: utm_term
        };
        common.setCookie("utmObj", JSON.stringify(utmObj));
    } else {
        if (common.getCookie("utmObj")) {
            utmObj = JSON.parse(common.getCookie("utmObj"));
        }
    }
})();

export default utmObj;
// utm赋值操作
// var postData = {
//     utmSource: utmObj.utm_source,
//     utmMedium: utmObj.utm_medium,
//     utmCampaign: utmObj.utm_campaign,
//     utmContent: utmObj.utm_content,
//     utmTerm: utmObj.utm_term,
// };
